(function () {
  if (!document.body.classList.contains('template-product')) {
    return;
  }

  function selectedTilkoebIds() {
    return Array.prototype.slice
      .call(document.querySelectorAll('[data-tilkoeb-variant]:checked'))
      .map(function (input) {
        return input.value;
      })
      .filter(Boolean);
  }

  function cartAddUrl() {
    if (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) {
      return window.Theme.routes.cart_add_url + '.js';
    }
    return '/cart/add.js';
  }

  function cartUrl() {
    if (window.Theme && window.Theme.routes && window.Theme.routes.cart_url) {
      return window.Theme.routes.cart_url + '.js';
    }
    return '/cart.js';
  }

  function moneyFormat() {
    var sectionDataEls = document.querySelectorAll('[data-section-data]');
    for (var i = 0; i < sectionDataEls.length; i += 1) {
      try {
        var sectionData = JSON.parse(sectionDataEls[i].textContent);
        if (sectionData && sectionData.settings && sectionData.settings.money_format) {
          return sectionData.settings.money_format;
        }
      } catch (e) {}
    }

    var currencySettingsEl = document.querySelector('[data-currency-converter-settings]');
    if (currencySettingsEl) {
      try {
        var currencySettings = JSON.parse(currencySettingsEl.textContent);
        if (currencySettings.money_format_no_currency) {
          return currencySettings.money_format_no_currency;
        }
        if (currencySettings.money_format) {
          return currencySettings.money_format;
        }
      } catch (e) {}
    }

    return null;
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      var format = moneyFormat();
      return format
        ? window.Shopify.formatMoney(cents, format)
        : window.Shopify.formatMoney(cents);
    }
    return (cents / 100).toFixed(2);
  }

  function addTilkoeb(id) {
    return fetch(cartAddUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        id: Number(id),
        quantity: 1,
      }),
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('tilkoeb add failed');
      }
      return response.json();
    });
  }

  function addAllTilkoeb(ids) {
    var added = [];
    return ids
      .reduce(function (chain, id) {
        return chain.then(function () {
          return addTilkoeb(id).then(function (item) {
            added.push(item);
            return item;
          });
        });
      }, Promise.resolve())
      .then(function () {
        return added;
      });
  }

  function fetchCart() {
    return fetch(cartUrl(), {
      headers: { Accept: 'application/json' },
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('cart fetch failed');
      }
      return response.json();
    });
  }

  function appendTilkoebToBanner(banner, items) {
    var targetEl = banner.querySelector('.atc-banner--product');
    if (!targetEl || !items.length) {
      return;
    }

    items.forEach(function (item) {
      var el = document.createElement('div');
      el.className = 'atc--product';
      el.innerHTML =
        '<div class="atc--product-image" data-atc-banner-product-image="">' +
        (item.image
          ? '<img src="' + item.image + '" alt="' + (item.product_title || '') + '">'
          : '') +
        '</div>' +
        '<div class="atc--product-details">' +
        '<h2 class="atc--product-details--title">' +
        (item.product_title || '') +
        '</h2>' +
        '<span class="atc--product-details--price">' +
        '<span class="atc--product-details--price-quantity">1 × </span>' +
        '<span class="atc--product-details--price-value money">' +
        formatMoney(item.price) +
        '</span>' +
        '</span>' +
        '</div>';
      targetEl.appendChild(el);
    });
  }

  function refreshCartUi(banner, cart) {
    if (window.jQuery) {
      window.jQuery('[data-site-header]').trigger('cartcount:update', {
        response: cart,
      });
    } else {
      var countEl = document.querySelector('[data-header-cart-count]');
      if (countEl) {
        countEl.setAttribute('data-header-cart-count', String(cart.item_count));
        countEl.classList.toggle('visible', cart.item_count > 0);
      }
    }

    if (banner) {
      var subtotal = banner.querySelector('[data-atc-banner-cart-subtotal]');
      if (subtotal) {
        subtotal.innerHTML = formatMoney(cart.total_price);
      }

      var cartButtonCount = banner.querySelector('[data-atc-banner-cart-button] span');
      if (cartButtonCount) {
        cartButtonCount.textContent = String(cart.item_count);
      }
    }

    if (window.api && window.api.theme && typeof window.api.theme.triggerEvent === 'function') {
      window.api.theme.triggerEvent('cart:updated', {
        cancel: function () {},
      });
    }
  }

  function waitForBanner(callback) {
    var attempts = 0;
    var maxAttempts = 40;
    var timer = setInterval(function () {
      attempts += 1;
      var banner = document.querySelector('section[data-atc-banner]');
      var bannerVisible = banner && banner.classList.contains('visible');

      if (bannerVisible || attempts >= maxAttempts) {
        clearInterval(timer);
        callback(bannerVisible ? banner : banner);
      }
    }, 150);
  }

  function onProductFormSubmit(event) {
    var form = event.target;
    if (!form || !form.hasAttribute('data-product-form')) {
      return;
    }

    if (!document.querySelector('[data-tilkoeb]')) {
      return;
    }

    var ids = selectedTilkoebIds();
    if (ids.length === 0) {
      return;
    }

    waitForBanner(function (banner) {
      addAllTilkoeb(ids)
        .then(function (addedItems) {
          if (banner) {
            appendTilkoebToBanner(banner, addedItems);
          }
          return fetchCart();
        })
        .then(function (cart) {
          refreshCartUi(banner, cart);
        })
        .catch(function () {
          // Main product already added; keep UX unblocked if addon refresh fails
        });
    });
  }

  document.addEventListener('submit', onProductFormSubmit, false);
})();
